import styled from "styled-components";

import * as Types from "Types";

import AtomRowIcon from "Components/Atoms/RowIcon";
import AtomDescription2 from "Components/Atoms/Description2";

const Wrap = styled.div<Types.Default>`
   display: flex;
   flex-direction: row;
   align-items: center;
   column-gap: 10px;
   ${({ css }) => css}
`;

const RowIcon = styled(AtomRowIcon)`
   & > img {
      height: 100%;
   }
   flex: none;
`;
const Description = styled(AtomDescription2)`
   display: inline-block;
   line-height: 23px;
   overflow-wrap: break-word;
   word-break: keep-all;
`;

function XSRow(props: Types.Default) {
   return <Wrap {...props}></Wrap>;
}

XSRow.Icon = RowIcon;
XSRow.Text = Description;

export default XSRow;
